// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-groupmsg-wrapper[data-v-e0c06c50] {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 38px;
  border-radius: 10px;
  overflow: hidden;
  flex-direction: column;
  margin-bottom: 0.85rem;
}
.chat-groupmsg-wrapper .fwd[data-v-e0c06c50] {
  font-size: .9em;
  display: flex;
  flex-direction: column;
  color: var(--fwd-message-color);
  margin-bottom: 0.33em;
}
.chat-groupmsg-wrapper .fwd.title[data-v-e0c06c50] {
  display: flex;
  flex-direction: row;
  height: 1em;
  margin-bottom: 0.4em;
}
.chat-groupmsg-wrapper .fwd.title i[data-v-e0c06c50] {
  margin-top: 0.4em;
  margin-right: 0.2em;
}
.chat-groupmsg-wrapper .chat-group-messages[data-v-e0c06c50] {
  display: grid;
  grid-template-columns: auto auto;
  row-gap: 2px;
  column-gap: 2px;
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message[data-v-e0c06c50] {
  position: relative;
  cursor: pointer;
  margin: auto;
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .blur-block[data-v-e0c06c50] {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .blur-block img[data-v-e0c06c50] {
  object-fit: cover;
  height: 100%;
  width: 100%;
  filter: blur(4px);
  -webkit-filter: blur(4px);
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .preview-block[data-v-e0c06c50] {
  display: flex;
  max-width: var(--preview-block-max-width);
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .img-wrapper[data-v-e0c06c50] {
  display: flex;
  overflow: hidden;
  height: 100%;
  margin: auto;
  flex-direction: column;
  border-radius: 10px;
}
.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .img-wrapper img[data-v-e0c06c50] {
  width: var(--group-image-width);
  height: var(--group-image-width);
  object-fit: cover;
}
.chat-groupmsg-wrapper .chat-group-messages .groupText[data-v-e0c06c50] {
  position: absolute;
  font-size: 20px;
  line-height: 22px;
  right: 4px;
  bottom: 2.2%;
  opacity: 0.7;
  background: #3231314a;
  border-radius: 8px;
  padding: 0 4px;
  backdrop-filter: blur(10px);
  background-color: #0e0e0e4d;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatGroupedMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;AAC7B","sourcesContent":[".chat-groupmsg-wrapper[data-v-e0c06c50] {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 100px;\n  min-height: 38px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-direction: column;\n  margin-bottom: 0.85rem;\n}\n.chat-groupmsg-wrapper .fwd[data-v-e0c06c50] {\n  font-size: .9em;\n  display: flex;\n  flex-direction: column;\n  color: var(--fwd-message-color);\n  margin-bottom: 0.33em;\n}\n.chat-groupmsg-wrapper .fwd.title[data-v-e0c06c50] {\n  display: flex;\n  flex-direction: row;\n  height: 1em;\n  margin-bottom: 0.4em;\n}\n.chat-groupmsg-wrapper .fwd.title i[data-v-e0c06c50] {\n  margin-top: 0.4em;\n  margin-right: 0.2em;\n}\n.chat-groupmsg-wrapper .chat-group-messages[data-v-e0c06c50] {\n  display: grid;\n  grid-template-columns: auto auto;\n  row-gap: 2px;\n  column-gap: 2px;\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message[data-v-e0c06c50] {\n  position: relative;\n  cursor: pointer;\n  margin: auto;\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .blur-block[data-v-e0c06c50] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .blur-block img[data-v-e0c06c50] {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  filter: blur(4px);\n  -webkit-filter: blur(4px);\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .preview-block[data-v-e0c06c50] {\n  display: flex;\n  max-width: var(--preview-block-max-width);\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .img-wrapper[data-v-e0c06c50] {\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n  margin: auto;\n  flex-direction: column;\n  border-radius: 10px;\n}\n.chat-groupmsg-wrapper .chat-group-messages .chat-group-message .img-wrapper img[data-v-e0c06c50] {\n  width: var(--group-image-width);\n  height: var(--group-image-width);\n  object-fit: cover;\n}\n.chat-groupmsg-wrapper .chat-group-messages .groupText[data-v-e0c06c50] {\n  position: absolute;\n  font-size: 20px;\n  line-height: 22px;\n  right: 4px;\n  bottom: 2.2%;\n  opacity: 0.7;\n  background: #3231314a;\n  border-radius: 8px;\n  padding: 0 4px;\n  backdrop-filter: blur(10px);\n  background-color: #0e0e0e4d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
